import { createSlice } from "@reduxjs/toolkit";
import { fetchUserAuthById } from "../actions/userAuthActions";

const initialState = {
    userAuth: [],
    loading: false,
    error: null,
    updateLoading: false, // Novo estado para o loading da atualização
    updateError: null,   // Novo estado para o erro da atualização
};

const userSlice = createSlice({
    name: "userAuth",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserAuthById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserAuthById.fulfilled, (state, action) => {
                state.loading = false;
                state.userAuth = action.payload.data;
            })
            .addCase(fetchUserAuthById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default userSlice.reducer;